import { Modal } from "react-bootstrap";
import ModalPortal from "../../fplist/ModalPortal";

const ContentsCardModalSecond = ({ onClose, contentsImage, isOpen }: any) => {
    return (
        <ModalPortal>
            <Modal show={isOpen}>
            <div className="modal-header">
                    <div className="d-flex align-items-center modal-title">
                        <div>치아보험</div>
                    </div>
                </div>
                <div className="modal-body">
                    <img className="img-fluid w-100" src="https://fphouse.blob.core.windows.net/knowledge/knowledge_64f180d2a6b6d.jpg" alt="Image Description" />
                    <img className="img-fluid w-100" src="https://fphouse.blob.core.windows.net/knowledge/knowledge_64f180d2d05ab.jpg" alt="Image Description" />
                    <img className="img-fluid w-100" src="https://fphouse.blob.core.windows.net/knowledge/knowledge_64f180d3049f7.jpg" alt="Image Description" />
                    <img className="img-fluid w-100" src="https://fphouse.blob.core.windows.net/knowledge/knowledge_64f180d328e3d.jpg" alt="Image Description" />
                    <img className="img-fluid w-100" src="https://fphouse.blob.core.windows.net/knowledge/knowledge_64f180d34e597.jpg" alt="Image Description" />
                </div>
                <div className="d-flex modal-footer w-100">
                    <button type="button" className="w-100 btn btn-secondary" onClick={onClose}>닫기</button>
                </div>
            </Modal>
        </ModalPortal>
    )
}

export default ContentsCardModalSecond;